// Import Swiper and modules
import AOS from 'aos';
import Swiper, { Navigation, Pagination, EffectFade, Autoplay, Thumbs, Lazy } from 'swiper';
import {toLower} from 'lodash-es'
// Install modules
Swiper.use([Navigation, Pagination, EffectFade, Autoplay, Thumbs, Lazy ]);

export function initSwiper() {
	const initSwiper = document.querySelectorAll('[data-swiper]');
	initSwiper.forEach((element) => {
		let params = JSON.parse(element.dataset.swiper);
		new Swiper(element, params);
	});
}

export function storySlider() {
	const initStorySlider = document.querySelectorAll('.storySlider');
	initStorySlider.forEach((element, idx) => {

		//console.log(element)
		let slidecount = element.querySelectorAll('.slide');
		//console.log(slidecount.length)
		let params = JSON.parse(element.dataset.storySwiper);

		function handleNextClick(e) {
				e.preventDefault();
				$('#homepage-story > .swiper-button-next').trigger('click');
				//console.log('next clicked')
				
		}

		params.on = {
			slideChangeTransitionStart: function () {
			  	$('.swiper-slide-aos').hide(0);
			  	$('.storyBody__title').removeClass('aos-init').removeClass('aos-animate');
			  	$('.storyBody__rule').removeClass('aos-init').removeClass('aos-animate');
			  	$('.storyBody__excerpt').removeClass('aos-init').removeClass('aos-animate');
			  	$('.storyBody__actions').removeClass('aos-init').removeClass('aos-animate');
			  	$('.storyBody__icon_grid').removeClass('aos-init').removeClass('aos-animate');
			  	$('.storyBody__icon_grid__item').removeClass('aos-init').removeClass('aos-animate');
			},
			slideChangeTransitionEnd: function () {
				$('.swiper-slide-aos').show(0);
			  	AOS.init();
			},
			reachEnd: function(e) {
				//console.log('end')
				let next = e.navigation.nextEl
				if(next) {
					next.removeEventListener('click', handleNextClick)
					next.addEventListener('click', handleNextClick)
				}
			}
		}
		new Swiper(element, params);

		// call swiper events after render

		let swiper = element.swiper
		//console.log(swiper)

		if(swiper) {
			swiper.navigation.nextEl.classList.remove('swiper-button-lock');
			swiper.navigation.nextEl.classList.remove('swiper-button-disabled');
			swiper.navigation.prevEl.classList.add('swiper-button-lock');
			swiper.navigation.prevEl.classList.add('swiper-button-disabled');

			if(slidecount.length === 1) {
				let next = swiper.navigation.nextEl
				next.removeEventListener('click', handleNextClick)
				next.addEventListener('click', handleNextClick)
			}
			
			// hide next on last element
			if(idx === initStorySlider.length - 1) {
				// last element
				swiper.navigation.nextEl.classList.add('swiper-button-lock');
				swiper.navigation.nextEl.classList.add('swiper-button-disabled');
			}
			
		}
	});	
}

export function homepageStory() {
	const story = document.getElementById('homepage-story');
	if(story) {
		//let params = JSON.parse(story.dataset.story);
		const stories = document.querySelectorAll('[data-story]');
		let menu = [];
		stories.forEach((item) => {
			menu.push(item.dataset.story)
		})
		//console.log(menu)
		new Swiper(story, {
			slidesPerView: 1,
			speed: 300,
			autoplay: false,
			effect: 'fade',
			crossFade: true,
			loop: false,
			navigation: {
				nextEl: '#homepage-story > .swiper-button-next',
				prevEl: '#homepage-story > .swiper-button-prev',
			},
			pagination: {
				el: '#homepage-story > .swiper-pagination',
				clickable: true,
				renderBullet: function (index, className) {
					let id = menu[index].replace(/[\s]/gm, '-')
					id = toLower(id.replace(/[?!]/gm, ''))
					return '<span class="' + className + '" data-nav-to="' + id + '">' + (menu[index]) + '</span>';
				},
			},
			on: {
				slideChangeTransitionStart: function () {
					  $('.swiper-slide-aos').hide(0);
					  $('.storyBody__title').removeClass('aos-init').removeClass('aos-animate');
					  $('.storyBody__rule').removeClass('aos-init').removeClass('aos-animate');
					  $('.storyBody__excerpt').removeClass('aos-init').removeClass('aos-animate');
					  $('.storyBody__actions').removeClass('aos-init').removeClass('aos-animate');
				},
				slideChangeTransitionEnd: function () {
					$('.swiper-slide-aos').show(0);
					AOS.init();
				},
			}
		});
	}
}

export function paginationResetSlides() {
	let cats = document.querySelectorAll('.homepageStory__cats span');
	let story = document.getElementById('homepage-story');
	
	if(cats) {
		cats.forEach((cat, idx) => {

			function handleBulletClick() {
				let slides = cat.dataset.navTo;
				resetNestedSlides(slides);
			}

			function resetNestedSlides() {
				let storySliders = document.querySelectorAll('.storySlider');
				storySliders.forEach((slider) => {
					let params = JSON.parse(slider.dataset.storySwiper);
					let swiper = slider.swiper
					swiper.slideTo(0)
					swiper.activeIndex = 0
					swiper.slideReset()
					console.log(swiper.activeIndex)
				})

				// update parent slider progress
				// story.swiper.activeIndex = idx
				// console.log(story.swiper.activeIndex)
				// story.swiper.slideTo(idx)
				// story.swiper.slideReset()
				// story.swiper.updateProgress()

			}
			
			cat.removeEventListener('click', handleBulletClick)
			cat.addEventListener('click', handleBulletClick)
		})
	}
}
